export const ORIGIN = globalThis?.location?.origin || 'https://pixai.art'
